import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';

/**
 * A component for triggering interactions
 */
function SecondaryButton({
  id,
  size,
  title,
  ariaLabel,
  ariaPressed,
  iconType,
  type,
  iconPosition,
  className,
  isDisabled,
  isLoading,
  onPress,
  children
}) {
  return (
    <Button
      id={id}
      theme={'secondary'}
      size={size}
      title={title}
      type={type}
      ariaLabel={ariaLabel}
      ariaPressed={ariaPressed}
      iconType={iconType}
      iconPosition={iconPosition}
      className={className}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onPress={onPress}
    >
      {children}
    </Button>
  );
}

SecondaryButton.propTypes = {
  /**
   * The id of the button
   */
  id: PropTypes.string,
  /**
   * The size of the button
   */
  size: PropTypes.oneOf(['large']),
  /**
   * The title of the button
   */
  title: PropTypes.string,
  /**
   * The ARIA label of the button
   */
  ariaLabel: PropTypes.string,
  /**
   * The type of icon to display
   */
  iconType: PropTypes.string,
  /**
   * The positioning of the icon
   */
  iconPosition: PropTypes.oneOf(['left', 'right']),
  /**
   * The additional classes to be applied
   */
  className: PropTypes.string,
  /**
   * The flag for disabling the control
   */
  isDisabled: PropTypes.bool,
  /**
   * The flag for visualising a loading state
   */
  isLoading: PropTypes.bool,
  /**
   * The function to call when pressed
   */
  onPress: PropTypes.func,
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default SecondaryButton;
